var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "row" }, [
        _c("h2", { staticClass: "match-header" }, [
          _vm._v("Reference: " + _vm._s(_vm._f("capitalize")(_vm.title)))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "configuration-reference" }, [
        _vm.$route.params.reference == "education"
          ? _c("div", { staticClass: "card-row row" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Country")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "country", placeholder: "Country" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.country = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.country,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "country",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.country"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("country"),
                          expression: "errors.has('country')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("country")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("College")]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "college", placeholder: "College" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.college = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.college,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "college",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.college"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("college"),
                          expression: "errors.has('college')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("college")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("State")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "state", placeholder: "State" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.state = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.state,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "state",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.state"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("state"),
                          expression: "errors.has('state')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("state")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("City")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "city", placeholder: "City" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.city = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.city,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "city",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.city"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("city"),
                          expression: "errors.has('city')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("city")))]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.params.reference == "location"
          ? _c("div", { staticClass: "card-row row" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Country")]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "country", placeholder: "Country" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.country = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.country,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "country",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.country"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("country"),
                          expression: "errors.has('country')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("country")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("State")]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "state", placeholder: "State" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.state = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.state,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "state",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.state"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("state"),
                          expression: "errors.has('state')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("state")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("City")]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "city", placeholder: "City" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.city = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.city,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "city",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.city"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("city"),
                          expression: "errors.has('city')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("city")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Latitude")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "latitude", placeholder: "Latitude" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.latitude = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.latitude,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "latitude",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.latitude"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("latitude"),
                          expression: "errors.has('latitude')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("latitude")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Longitude")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "longitude", placeholder: "Longitude" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.longitude = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.longitude,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "longitude",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.longitude"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("longitude"),
                          expression: "errors.has('longitude')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("longitude")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Population")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: {
                          name: "population",
                          placeholder: "Population"
                        },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.population = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.population,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "population",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.population"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("population"),
                          expression: "errors.has('population')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("population")))]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.params.reference == "organization"
          ? _c("div", { staticClass: "card-row row" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Name")]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "name", placeholder: "Name" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.name = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("name"),
                          expression: "errors.has('name')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("name")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("URL")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "url", placeholder: "URL" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.url = _vm.sanitizeUrl($event)
                          }
                        },
                        model: {
                          value: _vm.configurationObj.url,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "url",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.url"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("url"),
                          expression: "errors.has('url')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("url")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Category")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "category", placeholder: "Category" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.category = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.category,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "category",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.category"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("category"),
                          expression: "errors.has('category')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("category")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Market")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "market", placeholder: "Market" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.market = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.market,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "market",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.market"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("market"),
                          expression: "errors.has('market')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("market")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Status")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "status", placeholder: "Status" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.status = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.status,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "status",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.status"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("status"),
                          expression: "errors.has('status')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("status")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Country")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "country", placeholder: "Country" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.country = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.country,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "country",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.country"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("country"),
                          expression: "errors.has('country')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("country")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("State")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "state", placeholder: "State" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.state = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.state,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "state",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.state"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("state"),
                          expression: "errors.has('state')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("state")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Region")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "region", placeholder: "Region" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.region = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.region,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "region",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.region"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("region"),
                          expression: "errors.has('region')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("region")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("City")]),
                      _vm._v(" "),
                      _c("md-input", {
                        attrs: { name: "city", placeholder: "City" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.city = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.city,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "city",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.city"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("city"),
                          expression: "errors.has('city')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("city")))]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.params.reference == "roles"
          ? _c("div", { staticClass: "card-row row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Role")]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "role", placeholder: "Role" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.role = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.role,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "role",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.role"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("role"),
                          expression: "errors.has('role')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("role")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12 custom-textarea" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Description")]),
                      _vm._v(" "),
                      _c("md-textarea", {
                        attrs: { placeholder: "Description" },
                        on: {
                          blur: function($event) {
                            _vm.configurationObj.description = _vm.sanitizeInput(
                              $event.target.value
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.description,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "description",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.params.reference == "coaching-templates"
          ? _c("div", { staticClass: "card-row row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Title")]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "name", placeholder: "Title" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.name = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("name"),
                          expression: "errors.has('name')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("name")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Content")]),
                      _vm._v(" "),
                      _c("md-textarea", {
                        staticStyle: { "min-height": "180px" },
                        attrs: { placeholder: "Content", rows: "8" },
                        on: {
                          blur: function($event) {
                            _vm.configurationObj.content = _vm.sanitizeInput(
                              $event.target.value
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.content,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "content",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.content"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("content"),
                          expression: "errors.has('content')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("content")))]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.params.reference == "skills"
          ? _c("div", { staticClass: "card-row row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("skills")]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "skill", placeholder: "Skills" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.skills = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.skills,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "skills",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.skills"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("skill"),
                          expression: "errors.has('skill')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("skill")))]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.params.reference == "filter-words"
          ? _c("div", { staticClass: "card-row row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Word")]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "word", placeholder: "Word" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.word = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.word,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "word",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.word"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("word"),
                          expression: "errors.has('word')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("word")))]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.params.reference == "interests"
          ? _c("div", { staticClass: "card-row row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", [_vm._v("Interest")]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "interest", placeholder: "Interest" },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.interest = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.interest,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "interest",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.interest"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("interest"),
                          expression: "errors.has('interest')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("interest")))]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.params.reference == "protopia-owner"
          ? _c("div", { staticClass: "card-row row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", { staticClass: "card-header" }, [
                        _vm._v("Add Owner Name")
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          name: "ownerName",
                          placeholder: "Add Owner Name"
                        },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.name = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("ownerName"),
                          expression: "errors.has('ownerName')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("ownerName")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", { staticClass: "card-header" }, [
                        _vm._v("Add Owner Email")
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'"
                          }
                        ],
                        attrs: {
                          name: "ownerEmail",
                          id: "ownerEmail",
                          placeholder: "Add Owner Email"
                        },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.email = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.email,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "email",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("ownerEmail"),
                          expression: "errors.has('ownerEmail')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("ownerEmail")))]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.params.reference == "wizard-content"
          ? _c("div", { staticClass: "card-row row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", { staticClass: "card-header" }, [
                        _vm._v("Add Headline")
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.continues",
                            value: "required|max:80|min:10",
                            expression: "'required|max:80|min:10'",
                            modifiers: { continues: true }
                          }
                        ],
                        attrs: {
                          name: "headline",
                          maxlength: 80,
                          placeholder: "Add Headline"
                        },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.headline = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.headline,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "headline",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.headline"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("headline"),
                          expression: "errors.has('headline')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("headline")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", { staticClass: "card-header" }, [
                        _vm._v("Add Introduction")
                      ]),
                      _vm._v(" "),
                      _c("md-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.continues",
                            value: "required|max:250|min:100",
                            expression: "'required|max:250|min:100'",
                            modifiers: { continues: true }
                          }
                        ],
                        attrs: {
                          maxlength: 250,
                          name: "introduction",
                          placeholder: "Add Introduction",
                          rows: "2"
                        },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.introduction = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.introduction,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "introduction",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.introduction"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("introduction"),
                          expression: "errors.has('introduction')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("introduction")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", { staticClass: "card-header" }, [
                        _vm._v("Add Content")
                      ]),
                      _vm._v(" "),
                      _c("md-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.continues",
                            value: "required|max:2000|min:250",
                            expression: "'required|max:2000|min:250'",
                            modifiers: { continues: true }
                          }
                        ],
                        attrs: {
                          maxlength: 2000,
                          name: "content",
                          placeholder: "Add Content",
                          rows: "2"
                        },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.content = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.content,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "content",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.content"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("content"),
                          expression: "errors.has('content')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("content")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "md-field",
                    { staticClass: "create-community" },
                    [
                      _c("label", { staticClass: "card-header" }, [
                        _vm._v("Add Close")
                      ]),
                      _vm._v(" "),
                      _c("md-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.continues",
                            value: "required|max:250|min:5",
                            expression: "'required|max:250|min:5'",
                            modifiers: { continues: true }
                          }
                        ],
                        attrs: {
                          maxlength: 250,
                          name: "close",
                          placeholder: "Add Close",
                          rows: "2"
                        },
                        on: {
                          input: function($event) {
                            _vm.configurationObj.close = _vm.sanitizeInput(
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.configurationObj.close,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.configurationObj,
                              "close",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "configurationObj.close"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("close"),
                          expression: "errors.has('close')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("close")))]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "submitBtn" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-raised md-round md-accent",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.updateData()
                    }
                  }
                },
                [_vm._v("\n\t\t\t\t\t\t\tSave\n\t\t\t\t\t\t")]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-raised md-round md-accent",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.cancel(_vm.$route.params.reference)
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34e627c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e627c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigurationEdit.vue
// module id = null
// module chunks = 